import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesWarehouseCreateMain } from './modules/ui/Main';

const WarehouseCreatePage = (
  <SuspensePage>
    <PagesWarehouseCreateMain />
  </SuspensePage>
);

export default WarehouseCreatePage;
